import React, { useRef } from "react";
import OTPInput from "react-otp-input";
import { Box, useTheme } from "@mui/material";
import "../styles/Signup.css";

function OTPinput(
  {
    otp,
    setOtp,
    setSubmissionStatus = () => {},
    inputClassName = "grm-otp-input-box",
    // MUI sx for the digit boxes; when given, each digit renders as a Box so
    // theme-scaled values and :focus-visible apply. Legacy callers keep inputClassName.
    inputSx,
    // Opt-in — only the OtpInputRenderer family (FarmerDbtVerification.js)
    // passes this. Other OTPinput consumers (legacy popups: VerifyOtpModal,
    // ChangeNumOTPPopup, Agent/OTPPopup, MemberDetails) keep the default
    // `renderSeparator` spacing untouched.
    boxGap,
  },
  inputId,
) {
  const inputRefs = useRef([]);
  const theme = useTheme();

  const handleChange = (otp) => {
    if (/^\d*$/.test(otp) && otp.length <= 6) {
      setOtp(otp);
      setSubmissionStatus({
        message: "",
        success: false,
        submitted: false,
      });
      const currentInputIndex = otp.length;
      if (currentInputIndex < inputRefs.current.length) {
        inputRefs.current[currentInputIndex].focus();
      }
    }
  };
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index]) {
      if (index > 0) {
        inputRefs.current[index - 1].focus();
      }
    }
  };
  const sharedInputProps = (props, index) => ({
    className: `${props.className || ""} otp-input-no-spinner`.trim(),
    ref: (el) => (inputRefs.current[index] = el),
    onKeyDown: (e) => handleKeyDown(e, index),
    autoFocus: index === 0,
  });
  const customRenderInput = (props, index) => {
    if (inputSx) {
      // Drop react-otp-input's default inline width:1em, which would beat sx.
      const { style, ...rest } = props;
      return <Box component="input" {...rest} {...sharedInputProps(props, index)} sx={inputSx} />;
    }
    return <input {...props} {...sharedInputProps(props, index)} />;
  };

  return (
    <OTPInput
      id={inputId}
      value={otp}
      inputType={"number"}
      onChange={handleChange}
      numInputs={6}
      containerStyle={{
        justifyContent: "center",
        maxWidth: "100%",
        ...(boxGap != null ? { gap: theme.spacing(boxGap) } : {}),
      }}
      shouldAutoFocus={true}
      inputStyle={inputSx ? undefined : inputClassName}
      renderSeparator={boxGap != null ? null : <span>&nbsp;</span>}
      renderInput={(props, index) => customRenderInput(props, index)}
    />
  );
}

export default OTPinput;
